import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Optimizes Unsplash image URLs for better performance
 * - Adds WebP format
 * - Adds quality parameter
 * - Adjusts width for displayed size
 */
export function optimizeImageUrl(url: string | null, width = 400): string {
  if (!url) {
    return `https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=${width}&fit=crop&fm=webp&q=80`;
  }
  
  // Only optimize Unsplash URLs
  if (url.includes('images.unsplash.com')) {
    // Remove existing parameters and add optimized ones
    const baseUrl = url.split('?')[0];
    return `${baseUrl}?w=${width}&fit=crop&fm=webp&q=80`;
  }
  
  return url;
}
